import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Input } from 'antd';
import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PersonalTask } from 'api/personal-tasks';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { CustomDueDatePicker } from 'components/atoms/due-date-picker';
import { Loading } from 'components/atoms/loading/index';
import { ListItem } from 'components/molecules/tasks/list-item';
import { useTranslation } from 'hooks/use-translation';
import styles from './personal-tasks.module.css';

const { TextArea } = Input;

interface PersonalTaskItemProps {
  data: PersonalTask;
  handleTaskNameChange: (e, data) => void;
  handleDueDateChange?: (e, data) => void;
  handleStatusChange?: (e, data) => void;
  onDelete?: (data) => void;
  isDeleting: boolean;
  isCreating: boolean;
}

export const PersonalTaskItem: FC<PersonalTaskItemProps> = (props) => {
  const {
    data,
    handleTaskNameChange,
    onDelete,
    handleDueDateChange,
    handleStatusChange,
    isDeleting,
    isCreating,
  } = props;
  const translatedInputPlaceholderText = useTranslation(
    'personal_tasks.input.placeholder',
  );
  const [isInputActive, setIsInputActive] = useState(false);
  const [isChecked, setIsChecked] = useState(data.status === 'Completed');
  const [taskName, setTaskName] = useState(data.personalTaskName);

  useEffect(() => {
    setTaskName(data.personalTaskName);
  }, [data]);

  const handleStatus = (e) => {
    if (data.personalTaskId === 0) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (handleStatusChange) {
      setIsChecked(!isChecked);
      handleStatusChange(e, data);
    }
  };

  const handleDueChange = ([, due]) => {
    if (handleDueDateChange) {
      handleDueDateChange(due, data);
    }
  };

  return (
    <ListItem
      key={data.personalTaskId}
      isInputActive={isInputActive}
      content={
        <div className={styles.list_item_content}>
          {isCreating ? (
            <Loading size="small" className={styles.spinner} />
          ) : (
            <Checkbox
              checked={isChecked}
              className={styles.checkbox}
              onChange={handleStatus}
            />
          )}

          <TextArea
            autoSize={{ minRows: 1, maxRows: 2 }}
            value={taskName}
            onChange={(event) => setTaskName(event.target.value)}
            onPressEnter={(event) => {
              event.preventDefault();
              handleTaskNameChange(event.currentTarget.value, data);
            }}
            onBlur={(e) => handleTaskNameChange(e.currentTarget.value, data)}
            placeholder={translatedInputPlaceholderText}
            className={classNames(
              styles.add_task_input,
              styles.add_task_input__mod_update,
            )}
            onFocus={() => setIsInputActive(true)}
            onBlurCapture={() => setIsInputActive(false)}
          />
        </div>
      }
      overlay={
        Boolean(data.personalTaskId) && (
          <div className={styles.overlay}>
            <CustomDueDatePicker
              className={styles.due_date}
              canChooseStartDate={false}
              disabled={!data.personalTaskId}
              placeholder={<FormattedMessage id="due_date" />}
              size="small"
              dueDate={data.dueDate}
              onDateChange={handleDueChange}
            />
            <Button
              size="small"
              type="link"
              danger
              icon={<TrashCan16 />}
              loading={isDeleting}
              onClick={() => onDelete && onDelete(data)}
            />
          </div>
        )
      }
    />
  );
};
